import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './IconWithText.module.scss';
import Paragraph from '../Typography/Paragraph/Paragraph';
const IconWithText = ({ text, icon, className, borderRight, iconRight, onClick, size }) => {
    return (_jsxs("div", Object.assign({ onClick: onClick, className: cn(styles.element, 'd-flex', className, borderRight && styles['isBorder']) }, { children: [icon, _jsx(Paragraph, { fontFamily: 'urbanist', size: size, className: styles.startStable, title: text }), iconRight] })));
};
export default IconWithText;
